// extracted by mini-css-extract-plugin
export default {"root":"Search_root__QcbMb","input":"Search_input__MNDzf","icon":"Search_icon__gAIZd","clearIcon":"Search_clearIcon__sbaol"};